import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { style: {"position":"absolute","width":"100%","left":"0"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"60px"} }, null, -1)
const _hoisted_5 = { style: {"margin-top":"80px","position":"absolute","width":"100%","left":"0"} }
const _hoisted_6 = ["width", "height"]
const _hoisted_7 = ["width", "height"]
const _hoisted_8 = {
  class: "col-12",
  style: {"position":"absolute","left":"0","display":"inline-block"}
}
const _hoisted_9 = {
  style: {"text-align":"left"},
  class: "col-9 offset-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "削孔長 : ", -1)
const _hoisted_11 = {
  style: {"text-align":"left"},
  class: "col-9 offset-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "削孔検出感度 :", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  style: {"background":"lightgray","position":"absolute","padding":"2%"},
  id: "test-circle-setting"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://opencv.jp/opencv-2svn/cpp/feature_detection.html#cv-houghcircles"
}, "HoughCircles パラメータ説明 http://opencv.jp/opencv-2svn/cpp/feature_detection.html#cv-houghcircles ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { style: {"display":"inline-block","width":"100px"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { style: {"z-index":"999999","position":"fixed","bottom":"0","left":"0","width":"100%","text-align":"center","background-color":"rgba(120,120,120,0.8)","color":"white","font-weight":"bold"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "デバッグ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "error", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { style: {"bottom":"10%","position":"absolute","width":"100%","left":"0"} }
const _hoisted_28 = { style: {"width":"66%","z-index":"9999","padding":"2px","position":"absolute","left":"16.3%"} }
const _hoisted_29 = { class: "show-excel col-3 offset-1" }
const _hoisted_30 = { class: "show-excel col-3 offset-1" }
const _hoisted_31 = {
  class: "show-excel",
  style: {"width":"100%","padding":"8px","background":"rgb(245,246,247)"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_36 = { class: "show-excel input-group input-group-sm mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "show-excel input-group-text",
  id: "inputGroupFileAddon01"
}, "エクセルファイルのインポート ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 offset-1 text-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "h5" }, "削孔長 ")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 offset-1 text-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "h5" }, "位置の調整 ")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", null, "レーザのツラから棒の先迄の長さ(m)", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("b", null, "レーザのツラからステイのツラ迄の長さ(m)", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("b", null, "カメラのツラからレーザのツラまでの長さ (mm)", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h3", null, "実際の値", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h3", null, "差", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CameraConnection = _resolveComponent("CameraConnection")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SpreadSheet = _resolveComponent("SpreadSheet")!
  const _component_SerialConnection = _resolveComponent("SerialConnection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-dark ms-1 col-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.showArea('Excel')))
      }, " エクセル "),
      _createElementVNode("button", {
        class: "btn btn-dark ms-1 col-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.showArea('Canvas')))
      }, " 計測 "),
      _createElementVNode("button", {
        class: "btn btn-dark ms-1 col-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.showArea('Setting')))
      }, " 設定 "),
      _hoisted_3
    ]),
    _hoisted_4,
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("canvas", {
          style: {"position":"absolute","left":"0","right":"0","margin":"auto"},
          ref: "canvas",
          width: $data.videoWidth,
          height: $data.videoHeight,
          onMousedown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchSetDetectingPoint && _ctx.touchSetDetectingPoint(...args))),
          onTouchstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.touchSetDetectingPoint && _ctx.touchSetDetectingPoint(...args)))
        }, null, 40, _hoisted_6),
        _createElementVNode("canvas", {
          style: {"position":"absolute","left":"0","right":"0","margin":"auto"},
          ref: "canvasOutput",
          width: $data.videoWidth,
          height: $data.videoHeight
        }, null, 8, _hoisted_7),
        _createVNode(_component_CameraConnection, {
          ref: "cameraConnection",
          style: {"display":"none"},
          media: $data.media1,
          videoWidth: $data.videoWidth,
          videoHeight: $data.videoHeight,
          canvas2dCtx: $data.canvas2dCtx,
          presetVideo: $data.presetVideo
        }, null, 8, ["media", "videoWidth", "videoHeight", "canvas2dCtx", "presetVideo"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(this.ceilDemicalPoint ( this.fullLength * 0.001 ,3 )) + " m 削孔径 : " + _toDisplayString(this.ceilDemicalPoint( this.diameter  * 0.1,1)) + " cm 位置情報: ", 1),
          _createElementVNode("a", {
            style: {"cursor":"pointer"},
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.gpsLink && $options.gpsLink(...args)))
          }, _toDisplayString($data.gps.lat) + "," + _toDisplayString($data.gps.lon), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString($data.testDetectCircleSetting) + " ", 1),
          _hoisted_13,
          _createElementVNode("button", {
            class: "btn btn-dark",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($data.testSettingVisble=!$data.testSettingVisble))
          }, " テスト | 削孔検出 設定 "),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createTextVNode(),
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("div", null, [
              _createTextVNode(" dp "),
              _createElementVNode("div", {
                class: "square",
                style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
              }, null, 4),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: "1",
                max: "2",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.testDetectCircleSetting.dp) = $event))
              }, null, 512), [
                [_vModelText, $data.testDetectCircleSetting.dp]
              ])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" minDist "),
              _createElementVNode("div", {
                class: "square",
                style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
              }, null, 4),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                step: "0.1",
                max: "254",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.testDetectCircleSetting.minDist) = $event))
              }, null, 512), [
                [_vModelText, $data.testDetectCircleSetting.minDist]
              ])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" param1 "),
              _createElementVNode("div", {
                class: "square",
                style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
              }, null, 4),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                max: "254",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.testDetectCircleSetting.param1) = $event))
              }, null, 512), [
                [_vModelText, $data.testDetectCircleSetting.param1]
              ])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" param2 "),
              _createElementVNode("div", {
                class: "square",
                style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
              }, null, 4),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                max: "254",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.testDetectCircleSetting.param2) = $event))
              }, null, 512), [
                [_vModelText, $data.testDetectCircleSetting.param2]
              ])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" maxRadius "),
              _createElementVNode("div", {
                class: "square",
                style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
              }, null, 4),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                max: "254",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.testDetectCircleSetting.maxRadius) = $event))
              }, null, 512), [
                [_vModelText, $data.testDetectCircleSetting.maxRadius]
              ])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" minRadius "),
              _createElementVNode("div", {
                class: "square",
                style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
              }, null, 4),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                max: "254",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.testDetectCircleSetting.minRadius) = $event))
              }, null, 512), [
                [_vModelText, $data.testDetectCircleSetting.minRadius]
              ])
            ])
          ], 512), [
            [_vShow, $data.testSettingVisble]
          ]),
          _createElementVNode("button", {
            style: {"margin":"1%"},
            class: "btn btn-dark",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($options.selectCircle && $options.selectCircle(...args)))
          }, " 削孔の選択 "),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("button", {
              style: {"margin":"1%"},
              class: "btn btn-dark",
              onClick: _cache[14] || (_cache[14] = ($event: any) => ($data.selectCircleMode=false))
            }, " 選択解除 ", 512), [
              [_vShow, $data.selectCircleMode]
            ])
          ])
        ], 512), [
          [_vShow, $data.isDebugMode]
        ]),
        _hoisted_19,
        _withDirectives(_createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createTextVNode(),
          _hoisted_22,
          _createElementVNode("span", null, " 半径 ピクセル数 : " + _toDisplayString($data.currentCircle.radius), 1),
          _hoisted_23,
          _createElementVNode("span", null, "avgLength : " + _toDisplayString($data.avgLength) + " fullLength : " + _toDisplayString($data.fullLength) + " diameter " + _toDisplayString($data.diameter), 1),
          _hoisted_24,
          _createElementVNode("span", null, " serial1 : " + _toDisplayString($data.serial1Value) + " serial2 : " + _toDisplayString($data.serial2Value), 1),
          _hoisted_25,
          _hoisted_26,
          _createElementVNode("span", null, " serial1 : " + _toDisplayString($data.serial1Error) + " serial2 : " + _toDisplayString($data.serial2Error), 1)
        ], 512), [
          [_vShow, $data.isDebugMode]
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          class: "col-2 btn btn-dark",
          style: {"position":"absolute","height":"300px","width":"300px","border-radius":"100%","left":"0","bottom":"10%"},
          onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.startMeasurement()))
        }, "計測開始"),
        _createElementVNode("button", {
          class: "offset-1 col-2 btn btn-dark",
          style: {"height":"300px","width":"300px","border-radius":"100%","right":"0","position":"absolute","bottom":"10%"},
          onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.stop()))
        }, "計測終了")
      ])
    ], 512), [
      [_vShow, $data.viewState.isCanvasShow]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("a", {
          class: "col-3 show-excel",
          onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.showExcelMenu('File'))),
          style: {"cursor":"pointer"}
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: $data.faFile,
            size: "lg"
          }, null, 8, ["icon"]),
          _createTextVNode(" 設定 ")
        ]),
        _createElementVNode("a", _hoisted_29, " 削孔長の入力開始セル : " + _toDisplayString(( $data.selectedFullLengthCell.row !==-1 ||  $data.selectedFullLengthCell.col !==-1) ? ($data.selectedFullLengthCell.row+1 ) +"-"+ $options.exchangeToColName( $data.selectedFullLengthCell.col +1  ) : "未選択"), 1),
        _createElementVNode("a", _hoisted_30, " 削孔径の入力開始セル : " + _toDisplayString(( $data.selectedDiameterCell.row !==-1 ||  $data.selectedDiameterCell.col !==-1) ? ($data.selectedDiameterCell.row+1) +"-"+ $options.exchangeToColName( $data.selectedDiameterCell.col +1 ) : "未選択"), 1),
        _createElementVNode("button", {
          class: "z-index:999; col-2 btn btn-dark",
          style: {"position":"fixed","height":"300px","width":"300px","border-radius":"100%","right":"0","bottom":"10%"},
          onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.showArea('Canvas')))
        }, "計測へ戻る"),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("a", {
            class: "show-excel",
            style: {"cursor":"pointer"},
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($options.selectCellMode && $options.selectCellMode(...args)))
          }, "入力開始セルの位置の選択"),
          _hoisted_33,
          _createElementVNode("a", {
            class: "show-excel",
            style: {"cursor":"pointer"},
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => ($options.saveXlsx && $options.saveXlsx(...args)))
          }, "エクセルファイルの保存"),
          _hoisted_34,
          _createElementVNode("a", {
            class: "show-excel",
            style: {"cursor":"pointer"},
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => ($options.exportXlsx && $options.exportXlsx(...args)))
          }, "エクセルファイルのエクスポート"),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("input", {
              onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => ($options.importXlsx && $options.importXlsx(...args))),
              type: "file",
              id: "inputGroupFile01",
              class: "show-excel form-control",
              "aria-describedby": "inputGroupFileAddon01"
            }, null, 32)
          ]),
          _hoisted_38
        ], 512), [
          [_vShow, $data.viewState.isExcelFileMenuShow]
        ]),
        _hoisted_39
      ]),
      _hoisted_40,
      _createTextVNode(),
      _hoisted_41,
      _createElementVNode("h2", null, _toDisplayString(this.filename), 1),
      _hoisted_42,
      (_openBlock(), _createBlock(_component_SpreadSheet, {
        key: $data.SpreadSheetKey,
        style: {"z-index":"999, margin:0 auto","position":"absolute","left":"0%"},
        ref: "spreadsheet",
        xSpreadSheetData: $data.xSpreadSheetData,
        xSpreadSheetOption: $data.xSpreadSheetOption
      }, null, 8, ["xSpreadSheetData", "xSpreadSheetOption"]))
    ], 512), [
      [_vShow, $data.viewState.isExcelShow]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("h4", {
        class: "h4",
        onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($options.onDebugMode && $options.onDebugMode(...args)))
      }, "レーザ距離センサの接続設定"),
      _hoisted_43,
      _createVNode(_component_SerialConnection, {
        ref: "measurementSerial",
        serial: $data.serial1
      }, null, 8, ["serial"]),
      _hoisted_44,
      _createVNode(_component_SerialConnection, {
        ref: "assistanceSerial1",
        serial: $data.serial2
      }, null, 8, ["serial"]),
      _createElementVNode("button", {
        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($options.calibrationStart && $options.calibrationStart(...args))),
        class: "btn btn-dark"
      }, " キャリブレーション開始 "),
      _withDirectives(_createElementVNode("div", null, [
        _hoisted_45,
        _createTextVNode(" [(実測値)ーA]÷B "),
        _hoisted_46,
        _createTextVNode(" A "),
        _withDirectives(_createElementVNode("input", {
          step: "0.000000001",
          type: "number",
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($data.calibrationA) = $event))
        }, null, 512), [
          [_vModelText, $data.calibrationA]
        ]),
        _createTextVNode(),
        _hoisted_47,
        _createTextVNode(" B "),
        _withDirectives(_createElementVNode("input", {
          step: "0.000000001",
          type: "number",
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($data.calibrationB) = $event))
        }, null, 512), [
          [_vModelText, $data.calibrationB]
        ]),
        _hoisted_48,
        _hoisted_49,
        _hoisted_50,
        _hoisted_51,
        _withDirectives(_createElementVNode("input", {
          step: "0.001",
          type: "number",
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($data.calibrationLongLengthMeter) = $event))
        }, null, 512), [
          [_vModelText, $data.calibrationLongLengthMeter]
        ]),
        _hoisted_52,
        _hoisted_53,
        _createTextVNode(),
        _hoisted_54,
        _withDirectives(_createElementVNode("input", {
          step: "0.001",
          type: "number",
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($data.calibrationShortLengthMeter) = $event))
        }, null, 512), [
          [_vModelText, $data.calibrationShortLengthMeter]
        ]),
        _createTextVNode(),
        _hoisted_55,
        _hoisted_56,
        _createTextVNode(),
        _hoisted_57,
        _withDirectives(_createElementVNode("input", {
          step: "1",
          type: "number",
          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($data.DiameterCorrectionValue.detectStartPoint) = $event))
        }, null, 512), [
          [_vModelText, $data.DiameterCorrectionValue.detectStartPoint]
        ]),
        _hoisted_58
      ], 512), [
        [_vShow, $data.isDebugMode]
      ]),
      _hoisted_59,
      _createElementVNode("div", null, [
        _hoisted_60,
        _createElementVNode("span", null, " serial1 : " + _toDisplayString($data.serial1Value) + " m ", 1),
        _createTextVNode(),
        _hoisted_61,
        _createElementVNode("span", null, " serial2 : " + _toDisplayString($data.serial2Value) + " m ", 1),
        _hoisted_62
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _hoisted_63,
        _createElementVNode("span", null, " serial1 : " + _toDisplayString($options.addValue( $data.serial1Value, $data.calibrationLongLengthMeter  , $data.calibrationShortLengthMeter )) + " m", 1),
        _createTextVNode(),
        _hoisted_64,
        _createElementVNode("span", null, " serial2 : " + _toDisplayString($options.addValue( $data.serial2Value,$data.calibrationLongLengthMeter , $data.calibrationShortLengthMeter)) + " m ", 1),
        _hoisted_65
      ], 512), [
        [_vShow, $data.isDebugMode]
      ]),
      _createElementVNode("button", {
        style: {"margin":"10px"},
        onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => ($options.calibrationAdd && $options.calibrationAdd(...args))),
        class: "btn btn-dark"
      }, " 設定する "),
      _hoisted_66
    ], 512), [
      [_vShow, $data.viewState.isSettingShow]
    ])
  ]))
}